import {GetterTree, MutationTree, Module, ActionTree} from 'vuex'
import {RootState, ConseillerState} from '../types'
import {apiUrl} from '@/config/service'
import axios from 'axios'

type ConseillerGetter = GetterTree<ConseillerState, RootState>

const state: ConseillerState = {
  conseillers: null
}

export const getters: ConseillerGetter = {
  conseillersGetter: (state) => state.conseillers
}

export const actions: ActionTree<ConseillerState, RootState> = {
  async getConseillersAction({commit}, queryParams) {
    const {data} = await axios.get(`${apiUrl}/conseiller`, {params: queryParams})
    commit('getConseillersMutation', data)
    return data
  }
}

const mutations: MutationTree<ConseillerState> = {
  getConseillersMutation(state, data) {
    state.conseillers = data
  }
}

export const conseiller: Module<ConseillerState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
